import i18n from "config/i18next";

i18n.addResources("es", "filterPolygon", {
  regionLabel: "Región",
  regionPlaceholder: "Seleccioná la región",
});
